const DashboardTitle = ({ title, svg }) => {
    return (
        <div className="DashboardTitle">
            <div className="titleContent">
                {svg}
                <h2>{title}</h2>
            </div>

            <div className="titleDivider"></div>
        </div>
    );
};

export default DashboardTitle;
